import { QueryKey } from '@/application/queryKeys';
import fetchV2Vaults from '@/infrastructure/migrate/fetchV2Vaults';
import { useNetwork } from '@nftx/react';
import { useQuery } from '@tanstack/react-query';

const useV2Vaults = () => {
  const network = useNetwork();

  return useQuery([QueryKey.V2_VAULTS, network], () => {
    return fetchV2Vaults({ network });
  });
};

export default useV2Vaults;
